import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { BLOG } from "@/constants/testIds";

export const PostCard = ({ p, index = 0 }) => (
  <Link to={`/blog/${p.slug}`} data-testid={BLOG.card(p.slug)} className="group block bg-white rounded-3xl overflow-hidden border border-[#F0EBE1] hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] fade-up" style={{ animationDelay: `${index * 80}ms` }}>
    {p.image && <img src={imgUrl(p.image)} alt={p.title} loading="lazy" className="w-full aspect-[16/10] object-cover" />}
    <div className="p-5 space-y-2">
      <p className="text-[11px] font-semibold uppercase tracking-widest text-[#E06D44]">Kiddee toy test</p>
      <h2 className="font-heading text-lg font-bold leading-snug group-hover:text-[#E06D44] transition-colors">{p.title}</h2>
      <p className="text-sm text-stone-600 line-clamp-3">{p.excerpt}</p>
    </div>
  </Link>
);

export default function BlogPage() {
  const [posts, setPosts] = useState(null);
  useSeo({ title: "Kiddee's Toy Tests: Honest Dog Toy & Gear Reviews | PetTok Shop", path: "/blog",
    description: "Kiddee, our toy-obsessed rat terrier, tests dog toys, chews, treats and walking gear. Read what passed and who each one suits." });
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)).catch(() => setPosts([])); }, []);
  return (
    <main data-testid={BLOG.page} className="pt-24 sm:pt-32 pb-16 max-w-6xl mx-auto px-5 sm:px-6 lg:px-10">
      <p className="text-xs font-semibold uppercase tracking-widest text-[#E06D44]">The Kiddee blog</p>
      <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight mt-2">Kiddee's toy tests</h1>
      <p className="mt-3 text-stone-600 max-w-2xl">Every toy and treat in the shop has to get past Kiddee first. Here's what she thought, and who each one suits.</p>
      {posts && posts.length === 0 && <p data-testid={BLOG.empty} className="mt-10 text-stone-500">New toy tests are on the way. Check back soon.</p>}
      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {(posts || []).map((p, i) => <PostCard key={p.slug} p={p} index={i} />)}
      </div>
    </main>
  );
}
